import Image from "next/image"

interface Props {
    users: {
        id: string
        name: string
        picture: string
    }[]
}

export function Collaborators({ users }: Props) {
    return (
        <div className="flex -space-x-0.5">
            {users.map((u) => (
                <Image
                    className="size-6 rounded-full bg-gray-50 ring-2 ring-white dark:bg-zinc-900 dark:ring-zinc-800"
                    key={u.id}
                    src={u.picture}
                    alt={u.name}
                    title={u.name}
                    width={24}
                    height={24}
                />
            ))}
        </div>
    )
}
